export const USERS_QUERY = `
query InternalUsers($first: Int, $last: Int, $after: String, $before: String, $text: String) {
  internal {
    internals(first: $first, last: $last, after: $after, before: $before, text: $text) {
      nodes {
        id
        name
        avatar
        email
        lastSignInAt
      }
      totalItems
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
}
`
